import React from 'react';
import Collapsible from 'react-collapsible';
import LabelFromAcordeon from '../labelFromAcordeon/labelFromAcordeon';
import Body from '../texts/body';

import './acordeon.css'
const Acordeon = ({ valor }) => {
    console.log(valor)
    return (

        <div className='acordeonProps'>
            {valor && valor.map(i => {
                
                return (
                
                    <Collapsible trigger={<LabelFromAcordeon value={i.Titulo} />}>
                    <ul className='AcordeonList'> 
                        {i.Texto.map(e=>{
                         return(
                            <li>{e}</li>
                         )   
                           
                             
                             
                          
                        })}
                           </ul>
                    </Collapsible>
                
                )
            })}
             {/*    <Collapsible trigger={<LabelFromAcordeon value={valueLabel} />}>
                    {/* <Body value={valueAcordeon} /> */}
                   {/*  <ul className='AcordeonList'>
                        <li>Tax consulting service</li>
                        <li>Perennial tax adviser</li>
                        <li>Tax services for M&A</li>
                        <li>Tax planning scheme design
                        </li>
                        <li>Tax refund for export</li>
                        <li>Invoice agency service (invoices issued by designated tax authorities)
                        </li>
                        <li>Business registration, change, cancellation services
                        </li>
                        <li>Tax compliance and tax filing services
                        </li>
                        <li>Tax training service</li>
                    </ul> */}
               {/*  </Collapsible> */}
            </div >
    );
}

            export default Acordeon;
